import { Box, Button, Grid, Typography, useMediaQuery } from "@mui/material";
import BasisAccountCard from "../components/TenantAccount/BasisAccountCard";
import PremiumAccountCard from "../components/TenantAccount/PremiumAccountCard";
import Wrapper from "../components/layout/Wrapper";
import { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import AccountForm from "../components/TenantAccount/AccountForm";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import theme from "../styles/styleTheme";
import { useTranslation } from "react-i18next";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import DoorFrontOutlinedIcon from "@mui/icons-material/DoorFrontOutlined";
import RateReviewOutlinedIcon from "@mui/icons-material/RateReviewOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import VpnKeyOutlinedIcon from "@mui/icons-material/VpnKeyOutlined";

const CreateTenantAccount = () => {
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [showPremium, setShowPremium] = useState(true);
  const [showBasis, setShowBasis] = useState(true);
  const [showBasisForm, setShowBasisForm] = useState(false);
  const [showPremiumForm, setShowPremiumForm] = useState(false);
  const { t } = useTranslation();

  const scrollTop = () => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  const handleAnimatePremium = () => {
    if (!isMobile) {
      setShowBasis(false);
      setShowPremiumForm(true);
    } else {
      setShowPremiumForm(true);
      setShowBasis(false);
      setShowPremium(false);
    }
    scrollTop();
  };

  const handleBackToOverviewPremium = () => {
    if (!isMobile) {
      setShowBasis(true);
      setShowPremiumForm(false);
    } else {
      setShowPremium(true);
      setShowBasis(true);
      setShowPremiumForm(false);
    }
  };

  const handleAnimateBasis = () => {
    if (!isMobile) {
      setShowPremium(false);
      setShowBasisForm(true);
    } else {
      setShowPremium(false);
      setShowBasis(false);
      setShowBasisForm(true);
    }
    scrollTop();
  };

  const handleBackToOverviewBasis = () => {
    if (!isMobile) {
      setShowPremium(true);
      setShowBasisForm(false);
    } else {
      setShowPremium(true);
      setShowBasis(true);
      setShowBasisForm(false);
    }
  };

  useEffect(() => {
    document.title = `${t("createAccount.createAccount")} - GoHome.rent`;
  }, []);

  return (
    <Wrapper>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        marginBottom={5}
        marginTop={4}
        sx={{ marginLeft: { xs: "24px", md: 0 } }}
      >
        <Typography variant="h1" marginBottom={2}>
          {t("profile.title")}
        </Typography>
      </Box>
      <Box
        display={"flex"}
        gap={3}
        sx={{
          flexDirection: { xs: "column", md: "row" },
          alignItems: { xs: "center", md: "" },
        }}
      >
        {showPremiumForm && (
          <AccountForm
            handleBackToOverview={handleBackToOverviewPremium}
            isPremium={true}
          />
        )}
        {showPremium && (
          <PremiumAccountCard
            handleAnimate={handleAnimatePremium}
            showPremiumForm={showPremiumForm}
          />
        )}

        {showBasis && (
          <BasisAccountCard
            handleAnimate={handleAnimateBasis}
            showBasisForm={showBasisForm}
          />
        )}
        {showBasisForm && (
          <AccountForm
            handleBackToOverview={handleBackToOverviewBasis}
            isPremium={false}
          />
        )}
      </Box>

      <Box marginTop={4}>
        <Button
          onClick={() =>
            (window.location.href = "https://dashboard.gohome.rent/sign-up")
          }
          size="large"
          startIcon={<PersonOutlineOutlinedIcon />}
          variant="text"
          color="primary"
          sx={{
            borderRadius: 0,
            borderBottom: "1px solid",
            padding: "0 2px 5px 2px",
            "&:hover": {
              backgroundColor: "transparent",
            },
          }}
        >
          {t("profile.create_landlord_account")}
        </Button>
      </Box>

      <Box marginTop={10}>
        <Typography variant={"h2"} sx={{ fontWeight: "400", marginBottom: 4 }}>
          {t("createAccount.how_it_works")}
        </Typography>

        <Grid container spacing={4} marginBottom={5}>
          <Grid item xs={12} sm={4}>
            <Box>
              <PersonOutlineOutlinedIcon />
            </Box>
            <Typography fontWeight={"500"} marginTop={1} marginBottom={1}>
              {t("createAccount.account")}
            </Typography>
            <Typography>{t("createAccount.account.text")}</Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Box>
              <LocalPhoneOutlinedIcon />
            </Box>
            <Typography fontWeight={"500"} marginTop={1} marginBottom={1}>
              {t("createAccount.planning")}
            </Typography>
            <Typography>{t("createAccount.planning.text")}</Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Box>
              <DoorFrontOutlinedIcon />
            </Box>
            <Typography fontWeight={"500"} marginTop={1} marginBottom={1}>
              {t("createAccount.viewing")}
            </Typography>
            <Typography>{t("createAccount.viewing.text")}</Typography>
          </Grid>
        </Grid>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={4}>
            <Box>
              <RateReviewOutlinedIcon />
            </Box>
            <Typography fontWeight={"500"} marginTop={1} marginBottom={1}>
              {t("createAccount.register")}
            </Typography>
            <Typography>{t("createAccount.register.text")}</Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Box>
              <DescriptionOutlinedIcon />
            </Box>
            <Typography fontWeight={"500"} marginTop={1} marginBottom={1}>
              {t("createAccount.contract")}
            </Typography>
            <Typography>{t("createAccount.contract.text")}</Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Box>
              <VpnKeyOutlinedIcon />
            </Box>
            <Typography fontWeight={"500"} marginTop={1} marginBottom={1}>
              {t("createAccount.checkin")}
            </Typography>
            <Typography>{t("createAccount.checkin.text")}</Typography>
          </Grid>
        </Grid>
      </Box>
    </Wrapper>
  );
};

export default CreateTenantAccount;
